import JsBarcode from "jsbarcode";


const etiquetaCodigoBarrasPdf = (opts) => {
  const {
    codigoBarras,
    descripcion,
    copias = 1,
    anchoMm = 80,
    altoMm = 40,
    codigoBarrasImg,
  } = opts || {};

  // Utilidad: mm -> pt
  const mmToPt = (mm) => Math.round(mm * 2.83465);

  // --- Generación de imagen del código de barras ---
  // Prioriza imagen proporcionada; si no, intenta con JsBarcode -> dataURL
  const getBarcodeDataURL = (value) => {
    if (codigoBarrasImg) return codigoBarrasImg;

    const JsBarcodeLib =
      // soporta distintos entornos
      (typeof JsBarcode !== "undefined" && JsBarcode) ||
      (typeof window !== "undefined" && window.JsBarcode) ||
      null;

    if (!JsBarcodeLib) return null; // no hay generador disponible

    // Crea un canvas temporal y genera el código
    const canvas =
      typeof document !== "undefined"
        ? document.createElement("canvas")
        : null;

    if (!canvas) return null;

    try {
      // Formato CODE128 es el más común y robusto
      JsBarcodeLib(canvas, String(value), {
        format: "CODE128",
        displayValue: false, // el texto lo pondremos nosotros aparte
        lineColor: "#000",
        width: 2,            // grosor de barra (ajusta según tu impresora)
        height: 48,          // alto del código en px del canvas
        margin: 0,
      });
      return canvas.toDataURL("image/png");
    } catch (e) {
      // Si algo falla, regresamos null para usar fallback en PDF
      return null;
    }
  };

  const barcodeDataURL = getBarcodeDataURL(codigoBarras);

  // Ajustes tipográficos
  const descLimpia = (descripcion || "").trim();
  const codigoTexto = String(codigoBarras || "").trim();

  // Para evitar etiquetas saturadas, limitamos a 2 líneas de descripción
  // (pdfMake no tiene "line-clamp", pero acortar el texto ayuda)
  const acortar = (txt, max = 60) => (txt.length > max ? txt.slice(0, max - 1) + "…" : txt);

  // Construye UNA etiqueta (página) con:
  // 1) Código de barras centrado
  // 2) Texto del código (legible) pequeño
  // 3) Descripción (1-2 líneas máx)
  // 4) Unidad
  const buildEtiqueta = (isFirst) => {
    // Margen pequeño; deja aires a la impresora térmica/hoja
    const margen = [mmToPt(3), mmToPt(3), mmToPt(3), mmToPt(3)];
    const anchoPt = mmToPt(anchoMm);
    const altoPt = mmToPt(altoMm);

    // Si NO hay dataURL del código, usamos un bloque de texto como fallback
    const barcodeNode = barcodeDataURL
      ? {
          image: barcodeDataURL,
          fit: [anchoPt - mmToPt(8), altoPt * 0.55], // ancho máx y ~55% del alto
          alignment: "center",
          margin: [0, 0, 0, 2],
        }
      : {
          // Fallback: un cuadro con el valor, para no romper la impresión
          table: {
            widths: ["*"],
            body: [[{ text: codigoTexto || "—", bold: true, fontSize: 12, alignment: "center", margin: [0, 6, 0, 6] }]],
          },
          layout: {
            hLineWidth: () => 0.5,
            vLineWidth: () => 0.5,
          },
          margin: [0, 0, 0, 2],
        };

    const content = [
      // Código de barras (o fallback)
      barcodeNode,

      // Texto legible del código
      {
        text: codigoTexto,
        alignment: "center",
        fontSize: 6,
        characterSpacing: 1,
        margin: [0, 0, 0, 2],
      },

      // Descripción (nombre de insumo)
      {
        text: acortar(descLimpia, 100),
        alignment: "center",
        fontSize: 6,
        bold: true,
        margin: [0, 0, 0, 1],
      },
    ];

    return {
      // Cada etiqueta va en su propia "página" para impresión por etiqueta
      pageSize: { width: anchoPt, height: altoPt },
      pageMargins: margen,
      // Evita cortes raros
      pageBreakBefore: () => false,
      content,
      // Para múltiples copias, pdfMake arma un array de páginas (ver abajo)
    };
  };

  // Armar N copias como páginas separadas
  const docs = [];
  for (let i = 0; i < Math.max(1, copias); i++) {
    docs.push(buildEtiqueta(i === 0));
  }

  // pdfMake acepta un solo docDefinition; cuando necesitas múltiples páginas
  // se construye con un "contenido" que incluye pageBreaks. Sin embargo,
  // como en este caso el tamaño de página cambia por etiqueta, es más limpio
  // devolver un docDefinition por copia usando "defaultStyle" común y
  // concatenar al imprimir. Alternativa: usamos "documents" internos.
  // Para mantener API simple, consolidamos en el primer doc y agregamos
  // las demás como "content" con pageBreak antes:
  const first = docs[0];
  if (docs.length > 1) {
    // Tomamos el tamaño de la primera (asumimos todas iguales)
    first.content = [
      ...first.content,
      ...docs.slice(1).flatMap((d) => [{ text: "", pageBreak: "before" }, ...d.content]),
    ];
  }

  // Puedes añadir estilos globales aquí si los necesitas
  first.defaultStyle = {
    fontSize: 8,
  };

  return first;
};

export default etiquetaCodigoBarrasPdf;